<template>
    <body class="mob-overflow">

        <div class="mainview_style viewapt_mainview_div">
            <header class="mob-display common--header">
                <b-row class="marginTopAlignment">
                    <b-col cols="2" v-on:click="backAction()"><img src="images/Back_white.svg" alt="" /></b-col>
                    <b-col cols="8" class="header-title text-center">VIEW APPOINTMENT</b-col>
                </b-row>
            </header>

            <header class="desk_display">
                <div id="header_content" class="common--header">
                    <p class="alignleft"></p>
                    <p class="aligncenter header-title">VIEW APPOINTMENT</p>
                    <p class="alignright" v-on:click="gomenu()">
                        <img src="images/Home@2x.png" alt/>
                    </p>
                </div>
                <div style="clearaligncenter: both"></div>
            </header>

            <b-container class="bv-example-row viewapt_height">
                <b-row align-h="center" class="row_height">
                    <b-col class="xs_col col-sm-10 col-md-7 col-lg-5 col_padding dev_position">

                        <div class="imageBgDiv" v-if="showAppt">
                            <img :src="userImage" class="viewApptUserImage" />
                        </div>

                        <div class="viewApptBgStyle" v-if="showAppt">
                            <b-container>
                                <label class="resourceTitle titleBig">
                                    {{ store.userDetails.fnm + ' '  + store.userDetails.lnm }}
                                    <!-- {{ store.us(" ", store.userDetails.lnm) }} -->
                                </label>

                                <b-row class="bar-code-placeholder">
                                    <b-col>
                                        <qrcode-vue
                                            v-bind:value="qrCodeValue"
                                            :size="size"
                                            level="H"
                                            background="#ffffff"
                                            foreground="#000000"
                                        ></qrcode-vue>
                                    </b-col>
                                    <label class="qrcodeLabel">{{ qrCodeValue }}</label>
                                </b-row>
                                <div class="" style="margin-top:20px;">
                                    <b-row class="rowStyle">
                                        <b-col class="txtAlignleft">
                                            <label class="labelStyle">{{ datetimelabel }}</label>
                                        </b-col>
                                        <div class="txtAlignRight rightmargin">
                                            <label class="labelStyle">{{ store.appointmentDetail.dateTime }}</label>
                                        </div>
                                    </b-row>
                                    <b-row class="rowStyle">
                                        <b-col class="txtleftSpacing">
                                            <label class="labelStyle">{{ locationlabel }}</label>
                                        </b-col>
                                        <div class="txtAlignRight rightmargin">
                                            <label class="labelStyle">{{ store.appointmentDetail.location }}</label>
                                        </div>
                                    </b-row>
                                </div>
                                <div class="desk_display buttonBottomAlign position_fixed footer_bottom" v-if="showAppt"
                                     style='margin-top: 40px;'>
                                    <b-container>
                                        <b-row align-h="center">
                                            <b-col class="xs_col col-sm-11 col-md-12 col-lg-12 col_padding col">
                                                <!-- <b-col class="col-11 col-md-9 col_padding">  -->
                                                <div class="btn-container_SpaceAdjusted text-center">
                                                    <a href="javascript:void(0);" @click="changeAppt" class="app--btn roundedButton">{{
                                                        changeApptTitle
                                                    }}</a>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row align-h="center">
                                            <!-- <b-col class="col-11 col-md-9 col_padding"> -->
                                            <b-col class="xs_col col-sm-11 col-md-12 col-lg-12 col_padding">
                                                <div class="btn-container_SpaceAdjusted text-center">
                                                    <a href="javascript:void(0);" @click="showCancelModal" class="app--btn roundedButton">{{
                                                        cancelApptTitle
                                                    }}</a>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-container>
                                </div>
                            </b-container>
                        </div>

                        <b-container class="noApptScheduleMsg">
                            <div v-if="!showAppt" class="successMsgdiv">
                                <label class="thankyouText">{{ store.appointmentDetail.noApptMsg }}</label>
                            </div>
                        </b-container>
                    </b-col>
                </b-row>
            </b-container>

            <!-- edit or cancel appointment -->

            <div class="mob-display buttonBottomAlign" v-if="showAppt">
                <b-container>
                    <b-row align-h="center">
                        <!-- <b-col class="col-11 col-md-9 col_padding"> -->
                        <b-col class="xs_col col-sm-12 col-md-12 col-lg-12 col_padding">
                            <div class="btn-container_SpaceAdjusted text-center">
                                <a href="javascript:void(0);" @click="changeAppt" class="app--btn roundedButton">{{ changeApptTitle }}</a>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row align-h="center">
                        <!-- <b-col class="col-11 col-md-9 col_padding"> -->
                        <b-col class="xs_col col-sm-12 col-md-12 col-lg-12 col_padding">
                            <div class="btn-container_SpaceAdjusted text-center">
                                <a href="javascript:void(0);" @click="showCancelModal" class="app--btn roundedButton">{{
                                    cancelApptTitle
                                }}</a>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>

            <!-- dialogs -->

            <b-modal ref="delete-modal" class="verticalCenterAlign" centered hide-header hide-footer>
                <label class="thankyouText">{{ apptDeletedMsg }}</label>

                <div class="rightAlign">
                    <a href="javascript:void(0);" @click="exitModal" class="exitHyperLinkStyle"> {{ this.ok }}</a>
                </div>
            </b-modal>
            <b-modal ref="cancel-modal" class="verticalCenterAlign" centered hide-header hide-footer>
                <label class="thankyouText">{{ this.cancelApptPopup }}</label>

                <div class="rightAlign">
                    <a href="javascript:void(0);" @click="cancelAppt" class="exitHyperLinkStyle"> {{ this.yes }}</a>
                    <a href="javascript:void(0);" @click="hideCancelModal" class="exitHyperLinkStyle"> {{ this.no }}</a>
                </div>
            </b-modal>
        </div>
        <Footer></Footer>
    </body>
</template>

<script>
import { store } from "@/store.js";
import QrcodeVue from "qrcode.vue";
import apiCall from "@/services/api/apicall";
import Footer from "@/components/footer";

export default {

    name: "Home",

    components: {
        QrcodeVue,
        Footer,
    },

    data: () => ({
        store: store,
        qrCodeValue: "",
        size: window.screen.availHeight <= "700" ? 90 : 120, // 112 : 140,
        showAppt: store.isAppointment,
        apptDeletedMsg: "",
        userImage: "",
    }),

    mounted() {
        this.size = window.screen.availHeight <= "700" ? 90 : 120; // 112 : 140,

        if (navigator.onLine) {
            this.qrCodeValue = store.registration.iid;

            if (store.appointmentDetail.gender == "Male") {
                this.userImage = "images/User Male.png";
            } else {
                this.userImage = "images/User female.png";
            }
        } else {
            this.showAppt = false;
            store.appointmentDetail.noApptMsg = this.checkInternetConnection;
        }
    },

    methods: {

        /* navigation */

        backAction() {
            this.$router.push({ path: "/app-home" });
        },
        gomenu() {
            this.$router.push({ path: "/app-home" });
        },
        changeAppt() {
            this.$router.push({ path: "/change_appointment" });
        },

        /* cancel appoitnment */

        showCancelModal() {
            this.$refs["cancel-modal"].show();
        },

        hideCancelModal() {
            this.$refs["cancel-modal"].hide();
        },

        cancelAppt() {
            var iid = store.registration.iid;

            apiCall.apiServiceCall("Delete", "", `/appt/${iid}`, "", "")
                .then((response) => {

                    this.apptDeletedMsg = response.data.message;
                    // 
                    if (response.data.status == 1) {
                        this.$refs["delete-modal"].show();
                        store.isAppointment = false;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 500) {
                        store.isAppointment = true;
                        store.appointmentDetail.noApptMsg = this.serverProblem;
                    } else if (error.response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (error.response.status == 504) {
                        this.signout();
                    } else {
                        this.apptDeletedMsg = error.response.data.message;
                    }
                });
        },

        exitModal() {
            this.$refs["delete-modal"].hide();
            this.$router.push({ path: "/app-home" });
        },
    },

};
</script>
